import { clsx } from 'clsx';
import { Link } from 'react-router';

// UI
import Menu from '@components/account-menu';
import Button from '@components/button';
import TariffPlans from '@components/tariff-plans';
import LoadingPlaceholder from './loading';

//images
import LogoImg from '@assets/logo-2.png';
import avatarPlaceholder from '@assets/avatar.png';

// store
import { useAppStore } from '@store/app-store';

// styles
import css from './styles.module.css';

interface IProps {
  displayOnMobile?: boolean;
  className?: string;
}

function AccountHeader(props: IProps) {
  const { displayOnMobile = false, className } = props;

  const { userData, isLoading } = useAppStore();

  if (isLoading || !userData) {
    return (
      <LoadingPlaceholder
        error={null}
        displayOnMobile={displayOnMobile}
        className={className}
      />
    );
  }

  const { user_info, user_tariff_info } = userData;

  const userAvatar =
    user_info.user_logo && user_info.user_logo.length > 0
      ? user_info.user_logo
      : avatarPlaceholder;

  return (
    <main
      className={clsx(
        css.root,
        { [css.displayOnMobile]: displayOnMobile },
        className,
      )}
    >
      <header className={css.header}>
        <Link className={css.headerLogo} to="/account">
          <img
            src={LogoImg}
            alt="TurboPush"
            title="TurboPush"
            className={css.logoImage}
          />
        </Link>

        <Menu
          trialPeriod={!!user_info.trial_days}
          toggleComponent={
            <img
              className={css.profilePhoto}
              src={userAvatar}
              alt=""
              title=""
            />
          }
        />
      </header>

      <footer className={css.headerFooter}>
        <TariffPlans tariffInfo={user_tariff_info} />

        <Link className={css.link} to="/account/tariffs">
          <Button>View plans</Button>
        </Link>
      </footer>
    </main>
  );
}

export default AccountHeader;
